export class FetchTransport {
    baseUrl;
    fetchImpl;
    constructor(baseUrl, fetchImpl = fetch) {
        // Trim a trailing slash so `${baseUrl}${path}` never doubles up.
        this.baseUrl = baseUrl.replace(/\/$/u, '');
        // Bind to globalThis: native `fetch` throws "Illegal invocation" if called
        // with `this` set to anything other than the global (which is what happens
        // when it's invoked as `this.fetchImpl(...)`). Binding fixes the method-call
        // site and is harmless for a custom fetch that ignores `this`.
        this.fetchImpl = fetchImpl.bind(globalThis);
    }
    async request(req) {
        const headers = { ...req.headers };
        const init = { method: req.method, headers };
        if (req.bodyText !== undefined) {
            headers['content-type'] = 'application/json';
            init.body = req.bodyText;
        }
        const res = await this.fetchImpl(`${this.baseUrl}${req.path}`, init);
        const text = await res.text();
        const json = text.length > 0 ? JSON.parse(text) : undefined;
        const outHeaders = {};
        res.headers.forEach((value, key) => {
            outHeaders[key] = value;
        });
        return { status: res.status, json, headers: outHeaders };
    }
}
//# sourceMappingURL=fetch-transport.js.map